var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5349 12.7223L19.2773 20.594C19.6688 20.9465 20.2725 20.9149 20.625 20.5234C20.9775 20.132 20.9458 19.5282 20.5544 19.1758L11.8119 11.304L19.6836 2.56164C20.036 2.1702 20.0044 1.56645 19.613 1.21399C19.2215 0.861533 18.6178 0.893174 18.2653 1.28462L10.3936 10.027L1.64535 2.15001C1.25391 1.79755 0.65016 1.82919 0.297701 2.22064C-0.0547569 2.61208 -0.0231159 3.21583 0.368329 3.56829L9.11661 11.4453L1.23887 20.1885C0.886416 20.58 0.918057 21.1837 1.3095 21.5362C1.70095 21.8886 2.30469 21.857 2.65715 21.4656L10.5349 12.7223Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a9fa71a7fd66987cb940dd6f98268388.svg";
export { ForwardRef as ReactComponent };